export const maritalStatus = {
  list: [
    { id: 0, label: 'ELEMENT.MARITAL_STATUS.UNDEFINED' },
    { id: 1, label: 'ELEMENT.MARITAL_STATUS.SINGLE' },
    { id: 2, label: 'ELEMENT.MARITAL_STATUS.MARRIED' },
    { id: 3, label: 'ELEMENT.MARITAL_STATUS.DIVORCED' }
  ]
}
